/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React from 'react'
import { Element } from "trux"
import { statHighlight } from "../../util/formatter"

export const PlayerStatsBaseballRow = ({stats, playerCount, isTraceFamilyGame}) => {
	return (
		<>
			<Element className="td stat">
                <Element tag="span"
                     className={statHighlight(
                         stats.reachedSafely_rank,
                         playerCount,
						 !isTraceFamilyGame
                     )}
                >
                    {stats.reachedSafely}
                </Element>
			</Element>
			<Element className="td stat">
				<Element tag="span"
			         className={statHighlight(
				         stats.atBat_rank,
				         playerCount,
						 !isTraceFamilyGame
			         )}
				>
                    {stats.atBat}
                </Element>
			</Element>
			<Element className="td stat">
				<Element tag="span"
			         className={statHighlight(
				         stats.defensivePlay_rank,
				         playerCount,
						 !isTraceFamilyGame
			         )}
				>
                    {stats.defensivePlay}
                </Element>
			</Element>
			<Element className="td stat">
				<Element tag="span">
                    {stats.positions.join(", ")}
                </Element>
			</Element>
		</>
	)
}